export class Gruppo {
  Nome: string;
  Codice: number;
  Descrizione: string;
  Codiceistanza: number;
}
